import { Fragment } from "react";
import { type UserAndPopulationStatsForOneJournal } from "../../../../common/types/index.js";
import styles from "../../pages/UserDashboard/UserDashboard.module.css";

interface ComparisonTableProps {
  readonly userStats: UserAndPopulationStatsForOneJournal[];
  readonly result: {
    totalDays: number;
    totalPapers: number;
    averageRandR: number;
  };
}

const ComparisonTable = ({ userStats, result }: ComparisonTableProps) => (
  <>
    <h2>Lifetime Statistics</h2>
    <div className={styles["lifetime-stats"]}>
      Total Days Waiting For First Review on Papers: {result.totalDays}
      <div>Total Papers Submitted: {result.totalPapers}</div>
      <div>Average First R&R Percentage: {result.averageRandR}%</div>
    </div>
    <h2>Stats Comparison</h2>
    <table className={styles["stats-table"]}>
      <thead>
        <tr>
          <th>Journal Name</th>
          <th>Categories</th>
          <th>Your Statistics</th>
          <th>Population Statistics</th>
        </tr>
      </thead>
      <tbody>
        {userStats.map((data) => {
          return (
            <Fragment key={data.journalFullName}>
              <tr>
                <td rowSpan={4}>{data.journalFullName}</td>
                <td>Avg. Time to First Decision</td>
                <td>{data.userStats.avgDaysToFirstDecision}</td>
                <td>{data.journalStats.avgDaysToFirstDecision}</td>
              </tr>
              <tr>
                <td>% needing at least one revision</td>
                <td>{data.userStats.pctReceivedRevisionOnInitialSub}%</td>
                <td>{data.journalStats.pctReceivedRevisionOnInitialSub}%</td>
              </tr>
              <tr>
                <td>% accepted after revisions</td>
                <td>{data.userStats.pctAcceptedAfterRevision}%</td>
                <td>{data.journalStats.pctAcceptedAfterRevision}%</td>
              </tr>
              <tr>
                <td>Sample Size</td>
                <td>{data.userStats.distinctManuscripts}</td>
                <td>{data.journalStats.distinctManuscripts}</td>
              </tr>
            </Fragment>
          );
        })}
      </tbody>
    </table>
  </>
);

export default ComparisonTable;
